// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","content":"content--f4674","imageBox":"imageBox--aa441"};